// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_86-4";
export var collapsed = "_86-1";
export var headerBar = "_86-0";
export var leftHeaderContent = "_86-3";
export var subjectContainer = "_86-2";